import { createFileRoute, redirect } from "@tanstack/react-router"
import { FinanceDonationsPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

const VALID_TABS = ["donation-pages", "donations"] as const

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/donations/$tabKey"
)({
  beforeLoad: ({ params }) => {
    if (!VALID_TABS.includes(params.tabKey as (typeof VALID_TABS)[number])) {
      throw redirect({
        to: "/finance/donations/$tabKey",
        params: { tabKey: "donations" },
      })
    }
  },
  component: () => (
    <AuthorizationGate resource={Resource.DONATION} action={Action.READ}>
      <FinanceDonationsPage />
    </AuthorizationGate>
  ),
})
